// removed by extract-text-webpack-plugin
module.exports = {"main":"Sjitq78VwK3DiqYlQYJkr"};


//////////////////
// WEBPACK FOOTER
// ./components/ActivityIcon.module.css
// module id = 2334
// module chunks = 1